// src/components/Login.js
import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert } from "@mui/material";
import { auth } from "../firebase_setup/firebase"; // твоят auth експорт
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError(""); // reset на предишни грешки
    if (!email || !password) {
      setError("Моля, въведете Email и Парола");
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log("Успешен логин:", userCredential.user);
      navigate("/dashboard"); // след успешен логин прехвърля към dashboard
    } catch (err) {
      console.error("Грешка при логин:", err);
      // Проверка за различни видове грешки
      if (err.code === "auth/user-not-found") setError("Няма потребител с този Email");
      else if (err.code === "auth/wrong-password") setError("Грешна парола");
      else if (err.code === "auth/invalid-email") setError("Невалиден Email");
      else setError("Грешен Email или Парола");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleLogin(); // Enter за логин
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 8, p:4, boxShadow:3, borderRadius:2 }}>
      <Typography variant="h5" gutterBottom>Вход в системата</Typography>

      {error && <Alert severity="error" sx={{ mb:2 }}>{error}</Alert>}

      <TextField
        label="Email"
        type="email"
        fullWidth
        margin="normal"
        value={email}
        onChange={e => setEmail(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <TextField
        label="Парола"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={e => setPassword(e.target.value)}
        onKeyPress={handleKeyPress}
      />

      <Button variant="contained" fullWidth sx={{ mt:2 }} onClick={handleLogin}>
        Вход
      </Button>
    </Box>
  );
}